<template>
	<div>
		<v-dialog v-model="openD" max-width="500" persistent>
			<v-card>
				<v-card-title class="headline text-xs-center" v-if="type === 'sincronización'">Sincronización de prescripciones</v-card-title>
				<v-card-title class="headline text-xs-center" v-else>Descargar {{type}} de prescripciones </v-card-title>
				<v-card-text>
					<v-menu
							key="menu1"
							ref="fechaInicial"
							v-if="url === 'prescripcionesHistorico'"
							v-model="fechaInicial.menu"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
					>
						<v-text-field
								slot="activator"
								label="Fecha Inicial"
								v-model="result.fechaInicial"
								name="Fecha inicial"
								prepend-icon="event"
								v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaInicial.minDate + ',' + fechaInicial.maxDate + ',true'"
								:error-messages="errors.collect('Fecha inicial')"
								readonly
						></v-text-field>
						<v-date-picker
								ref="picker"
								v-model="result.fechaInicial"
								locale="es-co"
								:min="fechaInicial.minDate"
								:max="fechaInicial.maxDate"
								@input="$refs.fechaInicial.save(result.fechaInicial)"
								@change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha inicial')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
						></v-date-picker>
					</v-menu>
					<v-menu
							key="menu"
							ref="fechaFinal"
							v-if="url === 'prescripcionesHistorico'"
							v-model="fechaFinal.menu"
							:close-on-content-click="false"
							:nudge-right="40"
							lazy
							transition="scale-transition"
							offset-y
							full-width
							min-width="290px"
					>
						<v-text-field
								slot="activator"
								label="Fecha Final"
								v-model="result.fechaFinal"
								name="Fecha final"
								prepend-icon="event"
								v-validate="'required|date_format:yyyy-MM-dd|date_between:' + fechaFinal.minDate + ',' + fechaFinal.maxDate + ',true'"
								:error-messages="errors.collect('Fecha final')"
								readonly
						></v-text-field>
						<v-date-picker
								ref="picker"
								v-model="result.fechaFinal"
								locale="es-co"
								:min="fechaFinal.minDate"
								:max="fechaFinal.maxDate"
								@input="$refs.fechaFinal.save(result.fechaFinal)"
								@change="() => {
							  let index = $validator.errors.items.findIndex(x => x.field === 'Fecha final')
							  $validator.errors.items.splice((index !== -1) ? index : 0, (index !== -1) ? 1 : 0)
							}"
						></v-date-picker>
					</v-menu>
					<v-text-field
							key="text1"
							v-if="url === 'prescriptionsync'"
							label="Número prescripción"
							v-model="result.prescripcion"
							name="Número prescripción"
							v-validate="'required'"
							:error-messages="errors.collect('Número prescripción')"
					></v-text-field>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
							@click="close"
					>
						{{load ? 'Cerrar' : 'Cancelar'}}
					</v-btn>
					<v-btn
							color="primary"
							:loading="load"
							:disabled="load"
							@click="submit"
					>
						Descargar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
  	props: {
  	    type: {
  	        type: String,
			default: 'prescripciones'
		}
	},
    data: () => ({
        url: null,
		fechaInicial: {
            menu: false,
            minDate: '1900-01-01',
            maxDate: new Date().toISOString().substr(0, 10)
		},
		fechaFinal: {
            menu: false,
            minDate: '1900-01-01',
            maxDate: new Date().toISOString().substr(0, 10)
		},
        openD: false,
        load: false,
		result: {
            fechaInicial: null,
            fechaFinal: null,
			prescription: null
		}
	}),
	watch: {
  	  'result.fechaInicial' (val) {
  	      if (val) {
  	          this.result.fechaFinal = this.moment(val).diff(this.moment(this.result.fechaFinal), 'days') > 0 ? val : this.result.fechaFinal
		  }
	  },
		'result.fechaFinal' (val) {
			if (val) {
				this.result.fechaInicial = this.moment(val).diff(this.moment(this.result.fechaInicial), 'days') < 0 ? val : this.result.fechaInicial
			}
		}
	},
	methods: {
  	    submit () {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.$store.commit('snackbar', {
                    	color: 'warning',
						message: this.url === 'prescriptionsync'
								? `Se está sincronizando la prescripción, este proceso puede tardar varios segundos.`
								: `Se está procesando la descarga del histórico de ${this.type}, este proceso puede tardar varios minutos.`
                    })
                    this.$emit('onProcessing', true)
                    this.load = true
					let url = this.url + (this.url === 'prescriptionsync'
							? `?prescription=${this.result.prescripcion}`
							: `?fechaInicio=${this.result.fechaInicial}&fechaFin=${this.result.fechaFinal}`)
                    this.axios.get(`${url}`)
                        .then(response => {
							this.$store.commit('snackbar', {
								color: 'success',
								message: this.url === 'prescriptionsync'
										? `La prescrición se sincronizó correctamente.`
										: `El histórico de prescripciones se descargo correctamente.`
							})
                            this.$emit('onProcessing', false)
                            this.$emit('onSuccess', true)
                            this.close()
                            this.load = false
                        }).catch(e => {
                        this.$emit('onProcessing', false)
                        this.$emit('onSuccess', false)
                        this.load = false
                        this.$store.commit('snackbar', {color: 'error', message: `al descargar el histórico`, error: e})
                    })
				}
            })
		},
		open (url) {
  	    	this.url = url
            this.result.fechaInicial = this.moment().format('YYYY-MM-DD'),
            this.result.fechaFinal = this.moment().format('YYYY-MM-DD'),
		  this.openD = true
		},
		loading (val = true) {
		  this.load = val
		},
		close () {
		  	this.openD = false
			setTimeout(() => {
                this.load = false
                this.result.fechaInicial = null
                this.result.fechaFinal = null
                this.result.prescription = null
                this.$validator.reset()
			}, 300)
		}
  	}
}
</script>

